import CurrencyFlagDefault from './currency-flag-default.vue';

export default CurrencyFlagDefault;
